import { NotificationsAPI } from "@/lib/api"
import { SET_NOTIFICATIONS } from "@/store/mutationTypes"
const state = {
  all: [],
  new: []
}

// getters
const getters = {
  getNotifications: (state, getters, rootState, rootGetters) => {
    return state.all
  },
  getNewNotifications: (state, getters, rootState, rootGetters) => {
    return state.new
  },
  getNotificationsByUserId: (state, getters) => id => {
    return getters.getNotifications.filter(el => el.user_id === parseInt(id))
  },
  getUnreadCount: getters => {
    return getters.getNotifications.filter(el => el.read).length()
  }
}

// actions
const actions = {
  async loadNotifications({ commit }) {
    commit(SET_NOTIFICATIONS, await NotificationsAPI.list())
  },
  async markAsRead({ commit, dispatch }, id) {
    await NotificationsAPI.markAsRead(id)
    await dispatch("loadNotifications")
  }
}

// --- mutations ---
// SET_NOTIFICATIONS
// reset
const mutations = {
  [SET_NOTIFICATIONS](state, notifications) {
    let ids = state.all.map(e => e.id)
    if (state.all.length != 0) {
      state.new = notifications.filter(e => !e.read && !ids.includes(e.id))
    }
    state.all = notifications
  },
  reset(state) {
    state.all.splice(0, state.all.length)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
